
export const en = {
  // Navigation
  "nav.home": "Home",
  "nav.listen": "Listen",
  "nav.about": "About",
  "nav.forArtists": "For Artists",
  "nav.brandsPartners": "Brands/Partners",
  "nav.ranchfireLive": "RanchFire Live!",
  "nav.media": "Media",
  "nav.podcast": "Podcast",
  "nav.contact": "Contact",
  "nav.listenNow": "Listen Now",
  "nav.followUs": "Follow Us",

  // Hero Section
  "hero.title": "Where Country Finds Its Home",
  "hero.subtitle": "Broadcasting the best country tunes, authentic stories, and ranch culture 24/7",
  "hero.listenLive": "LISTEN LIVE",
  "hero.exploreShows": "EXPLORE SHOWS",

  // About Section
  "about.title": "Our Story",
  "about.subtitle1": "Rooted. Real. Country.",
  "about.p1": "Across the Southwest, country music comes in many different styles and sounds. It lives close to the land and closer to the people. It played while work got done, families gathered, and long days turned into longer nights. It was in English and in Spanish. It blended naturally with other sounds not because anyone planned it, but because life demanded it.",
  "about.p2": "What some call the \"rise\" of something new is really the return of something familiar: Country music rooted in real places, carried by people who live it every day.",
  "about.highlight1": "This sound doesn't chase trends.",
  "about.highlight2": "It earns loyalty.",
  "about.p3": "At RanchFire, we play Country the way it's always existed—unfiltered, lived-in, and built to last.",
  "about.tagline": "Rooted. Real. Country.",

  // Programming Section
  "programming.title": "Curated Playlists, the ranchfire way",
  "programming.subtitle": "Handpicked collections for every mood and moment",
  "programming.playlist1.title": "Tex Mex Twang",
  "programming.playlist1.description": "🔥Tex Mex Twang blends country & Tex-Mex with grit and heart. From timeless ballads to fresh voices, it's the sound of wide-open roads, campfire nights, and real stories. Turn it up and let the fire burn—this is music that lives where tradition meets today.",
  "programming.playlist2.title": "The King's Highway- George Strait Tribute",
  "programming.playlist2.description": "Whether you're chasing sunsets on I-10 or two-stepping under Hill Country stars, The King's Highway is your soundtrack to loyalty, love, and Lone Star pride—featuring the classics and the South Texas spirit he's inspired to keep the boots tapping and hearts wide open.",
  "programming.playlist3.title": "Regio Country",
  "programming.playlist3.description": "🔥 RanchFire Radio presenta \"Regio Country\": una playlist que une el espíritu del country americano con el orgullo regio. Guitarras, acordeones y voces que cuentan historias de frontera y raíces norteñas.",
  "programming.playlist4.title": "Tejano Ranch Country",
  "programming.playlist4.description": "Boots, brass, and borderland soul. Tejano Ranch is where Texas Country meets Tejano groove—accordion riffs, steel guitars, and puro corazón. From honky-tonk highways to backyard bailes, this playlist rides the rhythm of South Texas pride. Saddle up and let the crossover play.",
  "programming.playlist5.title": "Borderline Baladas",
  "programming.playlist5.description": "RanchFire Radio's \"Borderline Baladas\" is a sonic pilgrimage through the Southwest—where desert soul meets Latino country. Featuring Mike Aguilar and the Coupes' \"Mexican Hero,\" this playlist honors grit, legacy, and the quiet power of borderland storytelling.",
  "programming.playlist6.title": "Island Country Sunsets",
  "programming.playlist6.description": "Golden hour meet coastal calm. Island Country Sunsets from RanchFire Radio blends country soul, Americana warmth, and coastal Tex-Mex grooves — a perfect soundtrack for winding down by the water, where the day fades and the stories begin.",

  // Listen Now Section
  "listenNow.title": "Listen Now",
  "listenNow.subtitle": "Tune into our live stream and experience the best of country",
  "listenNow.playButton": "PLAY LIVE",
  "listenNow.nowPlaying": "Now Playing",
  "listenNow.nowPlayingOn": "Now Playing on RanchFire",
  "listenNow.upNext": "Up Next",
  "listenNow.liveNow": "Live Now",
  "listenNow.listenLive": "Listen Live",
  "listenNow.openPlayer": "Open Player",
  "listenNow.playingInWindow": "Playing in separate window",
  "listenNow.streamInfo": "24/7 • HD Quality • Ad-Free",
  "listenNow.alsoOn": "Also on",
  "listenNow.recentlyPlayed": "Recently Played",
  "listenNow.feature.live": "24/7 Live",
  "listenNow.feature.liveDesc": "Non-stop music",
  "listenNow.feature.hd": "HD Quality",
  "listenNow.feature.hdDesc": "Crystal clear sound",
  "listenNow.feature.adFree": "Ad-Free",
  "listenNow.feature.adFreeDesc": "Pure music experience",
  "listenNow.popupBlocked": "Popup Blocked",
  "listenNow.popupBlockedDesc": "Your browser blocked the player popup. Click below to open it in a new tab instead — the music will keep playing while you browse!",
  "listenNow.cancel": "Cancel",

  // Blog Section
  "blog.title": "\"From the Ranch\" Podcast",
  "blog.subtitle": "Stories, interviews, and insights from the heart of country music",
  "blog.readMore": "Read More",
  "blog.viewAll": "View All Episodes",
  "blog.latestPosts": "Latest Posts",

  // Community Section
  "community.title": "RanchFire Live!",
  "community.subtitle": "Your Bi-Weekly Texas Country Briefing",
  "community.description": "Live events • Festivals • Music scenes • Lifestyle brands • Cultural momentum",
  "community.joinTitle": "Join RanchFire Live!",
  "community.deliveredBiweekly": "Delivered bi-weekly to your inbox",
  "community.feature.liveEvents": "Live Events:",
  "community.feature.liveEventsDesc": "Curated concerts and shows across Texas",
  "community.feature.festivals": "Festivals:",
  "community.feature.festivalsDesc": "Lineups, ticket alerts, and insider guides",
  "community.feature.musicScenes": "Music Scenes:",
  "community.feature.musicScenesDesc": "Regional sounds and emerging artists",
  "community.feature.lifestyleBrands": "Lifestyle Brands:",
  "community.feature.lifestyleBrandsDesc": "Texas Country fashion and culture",
  "community.feature.culturalMomentum": "Cultural Momentum:",
  "community.feature.culturalMomentumDesc": "What's shaping Red Dirt today",
  "community.successMessage": "Welcome to RanchFire Live! Check your inbox.",
  "community.errorMessage": "Something went wrong. Please try again.",
  "community.emailPlaceholder": "your@email.com",
  "community.subscribe": "Subscribe",
  "community.subscribing": "Joining...",
  "community.unsubscribeNote": "Unsubscribe anytime. We respect your inbox.",
  "community.learnMore": "Learn more about RanchFire Live!",

  // Contact Section
  "contact.title": "Are you a brand? Let's talk!",
  "contact.subtitle": "Have a question, song request, or want to partner with us? We'd love to hear from you!",
  "contact.letsConnect": "Let's Connect",
  "contact.connectDescription": "Whether you're an artist looking to get your music featured, a sponsor interested in partnerships, or a listener with feedback, we want to hear from you.",
  "contact.location": "Location",
  "contact.locationValue": "San Antonio, Texas, United States",
  "contact.email": "Email",
  "contact.followUs": "Follow Us",
  "contact.yourName": "Your Name",
  "contact.namePlaceholder": "John Doe",
  "contact.emailAddress": "Email Address",
  "contact.emailPlaceholder": "john@example.com",
  "contact.subject": "Subject",
  "contact.selectSubject": "Select a subject",
  "contact.artistSubmission": "Artist Submission",
  "contact.sponsorshipInquiry": "Sponsorship Inquiry",
  "contact.generalFeedback": "General Feedback",
  "contact.technicalSupport": "Technical Support",
  "contact.other": "Other",
  "contact.message": "Message",
  "contact.messagePlaceholder": "Tell us what's on your mind...",
  "contact.characters": "characters",
  "contact.sendMessage": "Send Message",
  "contact.sending": "Sending...",
  "contact.successTitle": "Message sent successfully!",
  "contact.successMessage": "We'll get back to you soon.",
  "contact.errorTitle": "Something went wrong.",
  "contact.errorMessage": "Please try again.",

  // Schedule Section
  "schedule.title": "Weekly Schedule",
  "schedule.subtitle": "Your guide to the best country music programming all week long",
  "schedule.monday": "Monday",
  "schedule.tuesday": "Tuesday",
  "schedule.wednesday": "Wednesday",
  "schedule.thursday": "Thursday",
  "schedule.friday": "Friday",
  "schedule.saturday": "Saturday",
  "schedule.sunday": "Sunday",
  "schedule.genreGuide": "Genre Guide",
  "schedule.listenNow": "Listen Now",
  "schedule.tuneInTo": "Tune in to",
  "schedule.with": "with",
  "schedule.forTheBest": "for the best",
  "schedule.music": "music",
  "schedule.broadcastingLive": "Broadcasting live at",
  "schedule.bringingYou": "bringing you authentic Texas sounds and unforgettable moments.",

  // Media Section
  "media.title": "Media",
  "media.subtitle": "Press Releases & News",
  "media.pressRelease": "Press Release",
  "media.headline": "RanchFire Radio Launches: A New Home for Authentic Country Music",
  "media.subheadline": "RanchFireRadio.com brings Texas Country, Red Dirt, and Tex-Mex Country to listeners worldwide",
  "media.downloadPressKit": "Download Press Kit",
  "media.mediaInquiries": "Media Inquiries",
  "media.pressKitTitle": "Press Kit",
  "media.pressKitSubtitle": "Download brand assets and media materials",
  "media.logos": "Logos",
  "media.brandAssets": "Brand Assets",
  "media.pressMaterials": "Press Materials",
  "media.mediaImages": "Media Images",
  "media.forAdditionalAssets": "For additional assets, contact",
  "media.close": "Close",
  "media.mediaInquiryTitle": "Media Inquiry",
  "media.mediaInquirySubtitle": "Get in touch with our press team",
  "media.yourName": "Your Name",
  "media.emailAddress": "Email Address",
  "media.mediaOutlet": "Media Outlet / Publication",
  "media.mediaOutletPlaceholder": "Texas Monthly, Rolling Stone, etc.",
  "media.yourMessage": "Your Message",
  "media.messagePlaceholder": "Tell us about your inquiry, interview request, or story angle...",
  "media.sendInquiry": "Send Inquiry",
  "media.sending": "Sending...",
  "media.inquirySent": "Inquiry Sent!",
  "media.inquiryResponse": "We'll get back to you within 24-48 hours.",
  "media.mediaContact": "Media Contact:",
  "media.tagline": "Rooted. Real. Country.",

  // Featured Editorial Section
  "featuredEditorial.title": "The Sound That Never Left",
  "featuredEditorial.p1": "What some call the rise of something new is really the return of something familiar. Country music rooted in real places, carried by people who live it every day. This sound doesn't chase trends. It earns loyalty.",
  "featuredEditorial.p2": "At RanchFire, we don't program moments—we build habits. Music for the long drive. Songs that hold up on repeat. Stories that don't need explaining.",
  "featuredEditorial.readStory": "Read the story →",

  // Footer
  "footer.copyright": "2026 © RanchFire Radio a division of RanchFire Multimedia, LLC",
  "footer.tagline": "Rooted. Real. Country.",
  "footer.quickLinks": "Quick Links",
  "footer.connect": "Connect",
  "footer.newsletter": "Newsletter",
  "footer.newsletterText": "Subscribe for updates and exclusive content",
  "footer.subscribe": "SUBSCRIBE",
  "footer.emailPlaceholder": "Your email",
  "footer.rights": "All rights reserved.",
  "footer.poweredBy": "Powered by Readdy",

  // Common Actions
  "actions.learnMore": "LEARN MORE",
  "actions.getStarted": "GET STARTED",
  "actions.contactUs": "CONTACT US",
  "actions.viewMore": "VIEW MORE",
  "actions.playNow": "PLAY NOW",
  "actions.subscribe": "SUBSCRIBE",
  "actions.submit": "SUBMIT",

  // Listen Live Strip
  "listenLiveStrip.nowPlaying": "Now Playing",
  "listenLiveStrip.listen": "LISTEN",

  // Artist Spotlight
  "artistSpotlight.title": "Artist Spotlight",
  "artistSpotlight.subtitle": "Discover Amazing Country Talent",
  "artistSpotlight.featured": "Featured Artist",
  "artistSpotlight.bio": "Biography",
  "artistSpotlight.listen": "LISTEN",

  // Orientation
  "orientation.title": "Welcome to RanchFire Radio",
  "orientation.subtitle": "Your Country Journey Starts Here",
  "orientation.step1": "Tune In",
  "orientation.step1Text": "Listen to our 24/7 live stream",
  "orientation.step2": "Explore",
  "orientation.step2Text": "Discover shows and content",
  "orientation.step3": "Connect",
  "orientation.step3Text": "Join our community",

  // Language
  "lang.en": "EN",
  "lang.es": "ES",
  "lang.english": "English",
  "lang.spanish": "Español"
};

export default en;
